{
  "id": "campaign-023",
  "name": "Crooked Square",
  "seed": "campaign:23",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    "............",
    "............",
    ".......ww...",
    "..,....ww...",
    ".~,,..x.....",
    "~.~.........",
    "............",
    "............",
    "............",
    "____________",
    ",b........b.",
    ".,..b..b....",
    ",.....#.....",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 8,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 23,
  "biome": "park",
  "par": {
    "reel": 6411,
    "push": 5463,
    "selfPropelled": 5040,
    "tractor": 4010,
    "zeroTurn": 3236,
    "fairway": 2038
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 22
    }
  }
}
